import SoftButton from "components/SoftButton";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";

export default function ConfirmationDialog({
  open,
  onClose,
  onAccept,
  acceptButtonText,
  dialogTitle,
  dialogContent,
  acceptButtonColor,
  notArray,
  waitAccept = false,
  isLoading = false,
}) {
  const handleAccept = () => {
    // give the accept the control to close the dialog so that it waits for the action to finish
    // before closing the dialog
    if (waitAccept) {
      return onAccept(onClose);
    }

    // Call the function passed in through props
    onAccept();
    onClose();
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={isLoading ? undefined : onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{dialogTitle}</DialogTitle>
        <DialogContent>
          {notArray ? (
            <DialogContentText id="alert-dialog-description">{dialogContent}</DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description">
              {dialogContent[0]}
              <strong>{dialogContent[1]}</strong> ?
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <SoftButton onClick={onClose} variant="outlined" color="info" disabled={isLoading}>
            Cancel
          </SoftButton>
          <SoftButton
            variant="contained"
            color={acceptButtonColor ? acceptButtonColor : "info"}
            onClick={handleAccept}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={20} color="inherit" /> : acceptButtonText}
          </SoftButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
